import { FC } from "react";
import { Stack } from "@mui/material";
import { IntegrationCustomMessageInfoSection } from "../../common/IntegrationCustomMessageInfoSection";

export const SlackIntegrationActionExecutedWorkflowInfo: FC = () => {
  return (
    <Stack>
      <IntegrationCustomMessageInfoSection
        start="Workflow"
        tail="{{workflow name}}"
        color="primary.main"
      />
      <IntegrationCustomMessageInfoSection
        start="Monthly Price"
        tail="{{$0.00}}"
      />
    </Stack>
  );
};
